import React from 'react';
import { Reveal } from '../ui/Reveal';
import SafeIcon from '../common/SafeIcon';

const cases = [
  {
    title: "$50M Office Building Valuation",
    tag: "Financing Approved",
    bgImage: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=800&auto=format&fit=crop",
    desc: "Complex valuation for a Class A office building in downtown DC, securing favorable refinancing terms."
  },
  {
    title: "Multi-Family Portfolio Analysis",
    tag: "Increased Confidence",
    bgImage: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?q=80&w=800&auto=format&fit=crop",
    desc: "Analyzed a 12-property portfolio. Detailed market rent analysis helped the syndicator raise capital efficiently."
  }
];

const CaseStudies = () => {
  return (
    <section className="bg-charcoal-900 py-24 border-b border-white/5">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl">
        <div className="grid md:grid-cols-2 gap-8">
          {cases.map((c, i) => (
            <Reveal key={i} delay={i * 0.2}>
              <div className="group relative h-80 rounded-lg overflow-hidden cursor-pointer">
                {/* Background Image representing the "video" thumbnail */}
                <div 
                  className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105"
                  style={{ backgroundImage: `url(${c.bgImage})` }}
                ></div>
                <div className="absolute inset-0 bg-charcoal-950/70 group-hover:bg-charcoal-950/50 transition-colors"></div>
                
                {/* Simulated Play Button / Icon */}
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-16 h-16 rounded-full border-2 border-gold-500 flex items-center justify-center text-gold-500 group-hover:bg-gold-500 group-hover:text-charcoal-950 transition-all">
                    <SafeIcon name="FileText" size={24} />
                  </div>
                </div>

                {/* Text Content */}
                <div className="absolute bottom-0 left-0 w-full p-6 bg-gradient-to-t from-charcoal-950 to-transparent">
                  <h4 className="text-white font-bold text-lg mb-1">{c.title}</h4>
                  <p className="text-gold-500 text-sm font-semibold">{c.tag}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default CaseStudies;